export default __webpack_public_path__ + "static/media/group-12@2x.8280dba5.png";